import {NgModule, NgModuleFactoryLoader, SystemJsNgModuleLoader} from '@angular/core';

import {BrowserModule} from '@angular/platform-browser';

import {AppCoreModule} from './core';
import {SsoModule} from "./sso";
import {LocalStorageModule} from 'angular-2-local-storage';
import {UtilsModule} from "./utils";
import {UIRouterModule} from '@uirouter/angular';
import {APP_BASE_HREF} from '@angular/common';
import {AppComponent} from "./core/app";
import { SquareSpaceModule } from './square-space';
@NgModule({
    imports: [
        BrowserModule,
        UIRouterModule.forRoot({useHash: true,otherwise:'/'}),
        UIRouterModule.forChild({states: []}),
        AppCoreModule,
        SsoModule,
        UtilsModule,
        SquareSpaceModule,
        LocalStorageModule.withConfig({
            prefix: 'sso',
            storageType: 'localStorage'
        })
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: ''
        },
        {
            provide: NgModuleFactoryLoader,
            useClass: SystemJsNgModuleLoader
        },

    ],
    entryComponents: [],
    bootstrap:[AppComponent]
})
//
export class AppModuleAngular {

}